export default {
  Content: 1,
}
